import { render, staticRenderFns } from "./ProuniNotEligible.vue?vue&type=template&id=c3fb01aa&scoped=true&"
import script from "./ProuniNotEligible.vue?vue&type=script&lang=ts&"
export * from "./ProuniNotEligible.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniNotEligible.vue?vue&type=style&index=0&id=c3fb01aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fb01aa",
  null
  
)

export default component.exports